var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrap"},[_vm._m(0),_c('el-link',{staticClass:"go-back",attrs:{"underline":false},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回上一页")]),_c('router-link',{staticClass:"go-index",attrs:{"to":"/"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/images/index/404.png")}})])
}]

export { render, staticRenderFns }